import { render } from "./PaginatorMob.vue?vue&type=template&id=729be590&scoped=true&ts=true"
import script from "./PaginatorMob.vue?vue&type=script&lang=ts"
export * from "./PaginatorMob.vue?vue&type=script&lang=ts"

import "./PaginatorMob.vue?vue&type=style&index=0&id=729be590&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-729be590"]])

export default __exports__